import createInstance from "./interceptors";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api";

class Administrator {
  getStatus() {
    const instance = createInstance();

    return instance.get(API_URL + "/status").then((response) => {
      return response.data;
    });
  }
  sendCSV(data) {
    const instance = createInstance({ responseType: "arraybuffer" });

    return instance
      .post(API_URL + "/user/upload", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  sendEmails() {
    const instance = createInstance();

    return instance.post(API_URL + "/mail/flush").then((response) => {
      return response.data;
    });
  }

  getCategories() {
    const instance = createInstance();

    return instance.get(API_URL + "/programs/cohorts").then((response) => {
      return response.data;
    });
  }
}

export default new Administrator();
